






























































































import {Component, Watch, Prop, Vue} from 'vue-property-decorator';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';

import EditAccessPermissions from './edit-access-permissions.vue';
import { mixins } from 'vue-class-component';

const md5 = require('md5');

@Component({})
export default class ItemsInWorkspace extends mixins(EditAccessPermissions) {
  @Prop({ default: {} })
  data: any;

  isShow: boolean = false;

  workspacesApi: WorkspacesApi = workspacesApi;

  async mounted() {
    this.activeWorkspace = this.data.activeWorkspace;
    const { id } = this.activeWorkspace;
    this.$store.commit('loading', true);

    this.workspacesApi.getWorkspaceItems({workspaceId:id})
      .then((data)=>{
        this.rows = data;
        this.isShow = true;
      })
      .finally(() => this.$store.commit('loading', false))
  }

  get formattersItems(){
    return {
      name: (h: Function, c: any, ctx: any, x: any) => {
        let body = [ x.nameFull ? x.nameFull : x.name ];

        const dependConstraint = this.genDependConstraint(x.id);
        if(dependConstraint) {
          body.push(...dependConstraint);
        }
        return h('td', null, body);
      },
    }
  }

  get headersItems() {
    return [
      {
        text: 'name',
        align: 'left',
        value: 'name',
        sortable: false
      },
    ]
  }
}
